<div
  class="flex flex-col w-full max-h-[400px]"
  [style.background-color]="cssStyle()?.background?.color1"
  [style.border-radius]="cssStyle()?.radius"
>
  <blaze-scroller [propagate]="false">
    @let imgSrc = image();
    @if (imgSrc) {
      <div class="w-full h-[128px]">
        <img
          class="w-full h-full object-cover object-center"
          [src]="imgSrc"
          (error)="onImageLoadingError()"
          alt=""
        />
      </div>
    }

    <div class="p-16 flex flex-col gap-8">
      <div>
        @let title = card().title;
        @if (title) {
          <div class="card-title" [style.color]="cssStyle()?.title?.color1">
            {{ datasetRow() | dataRowFieldValuePipe: title.name | formatDatasetRow: title }}
          </div>
        }

        @let description = card().description;
        @if (description) {
          <div class="card-description" [style.color]="cssStyle()?.description?.color1">
            {{
              datasetRow()
                | dataRowFieldValuePipe: description.name
                | formatDatasetRow: card().description
            }}
          </div>
        }
      </div>

      @let customFields = (card().customFields$ | async) || [];
      @if (customFields.length > 0) {
        <div class="additional-fields" [style.border-top-color]="cssStyle()?.divider?.color1">
          @for (field of customFields; let i = $index; track field.column) {
            <div
              class="flex items-baseline gap-8 no-wrap"
              [class.label-top]="field.labelBehavior === 'top'"
            >
              @if (field.label) {
                <div class="field-label" [style.color]="cssStyle()?.title?.color1">{{
                  field.label
                }}</div>
              }
              <div>
                @if (field.displayFormat === 'url') {
                  <a
                    class="field-value"
                    [href]="datasetRow() | dataRowFieldValuePipe: field.column ?? ''"
                    [style.color]="cssStyle()?.links?.color1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{
                      datasetRow()
                        | dataRowFieldValuePipe: field.column ?? ''
                        | formatValue: field.displayFormat
                    }}
                  </a>
                } @else if (field.displayFormat === 'tag') {
                  <blaze-tags-column-value
                    class="mt-4"
                    [value]="
                      datasetRow() | dataRowFieldValuePipe: getColumnName(field.column) || ''
                    "
                    [palette]="tagConfig()?.[i]?.palette"
                    [order]="tagConfig()?.[i]?.order"
                  />
                } @else {
                  <span class="field-value" [style.color]="cssStyle()?.description?.color1">
                    {{
                      datasetRow()
                        | dataRowFieldValuePipe: field.column ?? ''
                        | formatValue
                          : field.displayFormat ?? 'text'
                          : {
                              precision: field.precision,
                              currency: field.currency,
                              durationFormat: field.duration || 'h:mm',
                              dateFormat: field.dateFormat,
                              dateTimeFormat: field.dateTimeFormat,
                            }
                    }}
                  </span>
                }
              </div>
            </div>
          }
        </div>
      }

      @let actions = (card().actions$ | async) || [];
      @if (actions.length > 0) {
        <div class="custom-actions">
          @for (action of actions; track action.id) {
            <div>
              <button
                class="action-item"
                [ngClass]="
                  getActionClasses()?.(action.styleSheetTarget ?? action.styleSheetId) || []
                "
                [class.icon-right]="action.iconPosition === 'right'"
                [class.icon-only]="!action.label"
                [ngStyle]="getActionElementStyles(action)"
                type="button"
                (click)="onAction(action)"
              >
                @if (action.icon) {
                  <mat-icon [svgIcon]="action.icon" />
                }
                {{ action.label }}
              </button>
            </div>
          }
        </div>
      }
    </div>
  </blaze-scroller>
</div>
